import './style/index.js';

import _Breadcrumb from './Breadcrumb';

export type { BreadcrumbItemProps, BreadcrumbProps } from './BreadcrumbProps';
export * from './type';

export const Breadcrumb = _Breadcrumb;
export default Breadcrumb;
